import { render } from "./RollDifficulty.vue?vue&type=template&id=290e1a3d&scoped=true&ts=true"
import script from "./RollDifficulty.vue?vue&type=script&lang=ts"
export * from "./RollDifficulty.vue?vue&type=script&lang=ts"

import "./RollDifficulty.vue?vue&type=style&index=0&id=290e1a3d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290e1a3d"]])

export default __exports__